export default __webpack_public_path__ + "static/media/lamb-1.567f5528.png";